import React, { useMemo } from "react";
import styles from "./Button.module.scss";
import MuiButton from "@mui/material/Button";
import type { ButtonProps as MuiButtonProps } from "@mui/material/Button";
import { combineClasses } from "@/lib/utils";

interface ButtonProps extends Omit<MuiButtonProps, "variant" | "children" | "className"> {
  outlined?: boolean;
  large?: boolean;
  className?: string | undefined;
  children: React.ReactNode;
}
const Button: React.FC<ButtonProps> = ({
  outlined,
  large,
  className = "",
  children,
  ...props
}) => {
  const buttonClassName = useMemo(() => {
    return combineClasses(
      outlined ? styles.outlineButton : styles.primaryButton,
      large ? styles.largeButton : "",
    );
  }, [outlined, large]);

  return (
    <MuiButton
      {...props}
      variant={outlined ? "outlined" : "contained"}
      disableElevation
      className={combineClasses(styles.button, className, buttonClassName)}
    >
      {children}
    </MuiButton>
  );
};

export default Button;
